export const applyOrder = <T>(items: T[], order: string[], getKey: (i: T) => string): T[] => {
    const map = new Map(items.map(i => [getKey(i), i]));
    const ordered: T[] = [];
    for (const key of order) {
        const item = map.get(key);
        if (item) { ordered.push(item); map.delete(key); }
    }
    return [...ordered, ...map.values()];
};